var map = {
	"./Base": 729,
	"./Base/": 729,
	"./Base/index": 729,
	"./Base/index.js": 729,
	"./Base/style": 177,
	"./Base/style.js": 177,
	"./Clutch": 427,
	"./Clutch/": 427,
	"./Clutch/index": 427,
	"./Clutch/index.js": 427,
	"./Clutch/renderComponent": 1633,
	"./Clutch/renderComponent.js": 1633,
	"./Clutch/style": 1292,
	"./Clutch/style.js": 1292,
	"./NewUi": 1013,
	"./NewUi/": 1013,
	"./NewUi/index": 1013,
	"./NewUi/index.js": 1013,
	"./NewUi/style": 1293,
	"./NewUi/style.js": 1293,
	"./OldUi": 1014,
	"./OldUi/": 1014,
	"./OldUi/index": 1014,
	"./OldUi/index.js": 1014,
	"./OldUi/renderComponent": 1634,
	"./OldUi/renderComponent.js": 1634,
	"./OldUi/style": 1294,
	"./OldUi/style.js": 1294,
	"./SpireonNew": 1015,
	"./SpireonNew/": 1015,
	"./SpireonNew/index": 1015,
	"./SpireonNew/index.js": 1015,
	"./SpireonNew/renderComponent": 1635,
	"./SpireonNew/renderComponent.js": 1635,
	"./SpireonNew/style": 1295,
	"./SpireonNew/style.js": 1295,
	"./SpireonOld": 1016,
	"./SpireonOld/": 1016,
	"./SpireonOld/index": 1016,
	"./SpireonOld/index.js": 1016,
	"./SpireonOld/renderComponent": 1636,
	"./SpireonOld/renderComponent.js": 1636,
	"./SpireonOld/style": 1296,
	"./SpireonOld/style.js": 1296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;